module.exports = {"id":"174379","name":"Gonzalo Castro","rating":"75","photo":"./data/images/photos/0/174379.png","club":{"name":"Málaga CF","logo":"./data/images/clubs/MalagaCF.png"},"positions":["MG","AG","BU","AD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GonzaloCastro0.json
// module id = 1622
// module chunks = 0